import { GUIDE_STEPS } from "@/pages/internal/userServicesGuideContent";

type GuideStepRailProps = {
  activeId?: string;
};

export function GuideStepRail({ activeId }: GuideStepRailProps) {
  return (
    <nav
      aria-label="Guide sections"
      className="rounded-lg border border-slate-200 bg-slate-50/80 p-3 sm:p-4"
    >
      <p className="mb-3 text-xs font-medium uppercase tracking-wide text-slate-500">Workflow</p>
      <ol className="flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:gap-2">
        {GUIDE_STEPS.map((step, index) => {
          const isActive = activeId === step.id;
          return (
            <li key={step.id} className="sm:max-w-full">
              <a
                href={`#${step.id}`}
                className={[
                  "flex items-center gap-2 rounded-md px-3 py-2 text-sm transition-colors duration-200",
                  "hover:bg-white hover:text-slate-900",
                  isActive
                    ? "bg-white font-medium text-slate-900 shadow-sm ring-1 ring-slate-200"
                    : "text-slate-600",
                ].join(" ")}
              >
                <span
                  className={[
                    "flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-semibold",
                    isActive ? "bg-primary text-primary-foreground" : "bg-slate-200 text-slate-700",
                  ].join(" ")}
                >
                  {index + 1}
                </span>
                <span>{step.label}</span>
              </a>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
